import { useRef } from "react"

const useUpdateFaviconBadge = () => {
  const originalFaviconRef = useRef(null)

  const updateFavicon = (count = 0) => {
    try {
      const favicon = document.querySelector("link[rel~='icon']")

      if (!originalFaviconRef.current) {
        originalFaviconRef.current = favicon?.href || "/favicon.png"
      }

      if (count === 0) {
        if (favicon) favicon.href = originalFaviconRef.current
        document.title = document.title.replace(/^\(\d+\+?\)\s*/, "")
        return
      }

      const link = favicon || document.createElement("link")
      link.rel = "icon"

      const size = 48
      const canvas = document.createElement("canvas")
      canvas.width = size
      canvas.height = size
      const ctx = canvas.getContext("2d")

      const baseImg = new Image()
      baseImg.crossOrigin = "anonymous"
      baseImg.src = originalFaviconRef.current

      baseImg.onload = () => {
        ctx.clearRect(0, 0, size, size)
        ctx.drawImage(baseImg, 0, 0, size, size)

        const badgeSize = 26

        ctx.beginPath()
        ctx.fillStyle = "#25D366"
        ctx.arc(
          size - badgeSize / 2,
          badgeSize / 2,
          badgeSize / 2,
          0,
          Math.PI * 2
        )
        ctx.fill()

        ctx.fillStyle = "#fff"
        ctx.font = "bold 18px sans-serif"
        ctx.textAlign = "center"
        ctx.textBaseline = "middle"

        const text = count > 99 ? "99+" : String(count)
        ctx.fillText(text, size - badgeSize / 2, badgeSize / 2 + 1)

        link.href = canvas.toDataURL("image/png")

        if (!document.querySelector("link[rel~='icon']"))
          document.head.appendChild(link)
      }
    } catch (e) {
      document.title =
        (count > 0 ? `(${count}) ` : "") +
        document.title.replace(/^\(\d+\+?\)\s*/, "")
    }
  }

  return { updateFavicon }
}

export default useUpdateFaviconBadge
